export const getProduct = (data) => {
  return data.map((value) => {
    return value.name;
  }).join('、');
};
export const getCompany = (data, id) => {
  return data.find((value) => {
    return id === value.id;
  }).companyInfo.qichacha_name;
};
